import { LOGIN_SUCCESS, LOGIN_FAIL, LOGOUT, API_ERROR } from "./actionTypes";

const initialState = {
    user: null,
    error: null,
    isAuthenticated: false,
};

const loginReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_SUCCESS:
            return { ...state, user: action.payload, isAuthenticated: true, error: null };
        case LOGIN_FAIL:
            return { ...state, user: null, isAuthenticated: false, error: action.payload };
        case LOGOUT:
            return { ...state, user: null, isAuthenticated: false, error: null };
        case API_ERROR:
            return { ...state, error: action.payload };
        default:
            return state;
    }
};

export default loginReducer;